import { useState } from 'react'
import { RunWithDetails } from '../../types'
import { CalibrationProfileSelector } from './CalibrationProfileSelector'
import { CalibrationHelper } from './CalibrationHelper'
import { ManualProfileCreator } from './ManualProfileCreator'
import { CalibrationPreview } from './CalibrationPreview'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs'
import { Settings, Eye, Sliders, Database } from 'lucide-react'

interface CalibrationTabProps {
  run: RunWithDetails
}

export function CalibrationTab({ run }: CalibrationTabProps) {
  const [activeSubTab, setActiveSubTab] = useState('select')

  return (
    <div className="p-6 space-y-8">
      <div>
        <h2 className="text-2xl font-bold text-primary-900 mb-2">Pace Calibration</h2>
        <p className="text-neutral-600">
          Choose or create a pace model for accurate time estimates
        </p>
      </div>

      <Tabs value={activeSubTab} onValueChange={setActiveSubTab}>
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="select" className="flex items-center gap-2">
            <Settings className="h-4 w-4" />
            Select Profile
          </TabsTrigger>
          <TabsTrigger value="manual" className="flex items-center gap-2">
            <Sliders className="h-4 w-4" />
            Manual Setup
          </TabsTrigger>
          <TabsTrigger value="calibrate" className="flex items-center gap-2">
            <Database className="h-4 w-4" />
            From Data
          </TabsTrigger>
          <TabsTrigger value="preview" className="flex items-center gap-2">
            <Eye className="h-4 w-4" />
            Preview
          </TabsTrigger>
        </TabsList>

        <TabsContent value="select" className="space-y-6">
          <CalibrationProfileSelector
            runId={run.id}
            currentProfileId={run.calibration_profile_id}
          />
        </TabsContent>

        <TabsContent value="manual" className="space-y-6">
          <ManualProfileCreator
            onProfileCreated={() => setActiveSubTab('select')}
            run={run}
          />
        </TabsContent>

        <TabsContent value="calibrate" className="space-y-6">
          <CalibrationHelper onProfileCreated={() => setActiveSubTab('select')} />
        </TabsContent>

        <TabsContent value="preview" className="space-y-6">
          <CalibrationPreview run={run} />
        </TabsContent>
      </Tabs>
    </div>
  )
}